import React from 'react';
import {default as CloudinaryImageUI} from '@spothero/ui/cloudinary-image';
import CloudinaryImagePropTypes from '@spothero/ui/cloudinary-image-prop-types';
import WithConfig from 'config/WithConfig';

const CloudinaryImage = ({
    className,
    cloudinary,
    cloudinaryImageId,
    width,
    height,
    onLoad
}) => {
    return (
        <CloudinaryImageUI
            className={className}
            cloudinary={cloudinary}
            cloudinaryImageId={cloudinaryImageId}
            width={width}
            height={height}
            onLoad={onLoad}
        />
    );
};

CloudinaryImage.propTypes = CloudinaryImagePropTypes;

export default WithConfig(CloudinaryImage);
